import { Directive } from '@angular/core';
import { BrnPopoverContent } from '@spartan-ng/brain/popover';

@Directive({
  selector: '[hlmPopoverPortal]',
  exportAs: 'hlmPopoverPortal',
  hostDirectives: [{ directive: BrnPopoverContent, inputs: ['context', 'class'] }],
})
export class HlmPopoverPortal {}
